import { UNITED_STATES_BOUNDS } from '@records/records-search/esri-map/esri-map.model';
import { DEFAULT_GEOGRAPHY_VALUES } from '@records/records-search/records-search.constants';
import { MapState } from './map-state.model';

export const MAX_LOCAL_STORAGE_SIZE_PER_PAGE = 5200000;
export const RESULTS_DEFAULT_LIMIT = 50;

export const MAP_STATE = 'MAP_STATE';
// Changed the constant value from `QUERY_STATE` TO `SEARCH_STATE` to
// automatically ignore broken queries for all users (MIQ-11093, MIQ-10958, MIQ-10942... and others)
export const QUERY_STATE = 'SEARCH_STATE';
export const ENTITY = 'ENTITY';
export const DEFAULT_ENTITY = 'property';

// DEFAULT QUERY STATE
export const DEFAULT_QUERY_STATE = {
  entity: DEFAULT_ENTITY,
  geography: DEFAULT_GEOGRAPHY_VALUES,
  offset: 0,
  limit: RESULTS_DEFAULT_LIMIT,
  filters: [],
};

export const DEFAULT_MAP_STATE: MapState = {
  searchMode: '',
  currentBounds: UNITED_STATES_BOUNDS,
  showPendingOnly: false,
  mapBaseLayer: 'Streets',
};
